
if ($('form#geoLocateForm').length) {
    window.addEventListener('load', initializeAutocomplete);
}

function initializeAutocomplete() {

    //see if we need to initialize the Canada tab.
    let path = window.location.href.split('?')[1];
    if (path && path.length && path.match(/showCanada=true/)) {
        switchToCanda();
    }

    var input = document.getElementById('citiesAutoComplete');
    var autocomplete = new google.maps.places.Autocomplete(input);
    autocomplete.setComponentRestrictions({
        country: ["us", "ca"],
    });
    autocomplete.setTypes(["(regions)"]);
    autocomplete.setFields(["geometry", "address_component"]);


    var place = autocomplete.getPlace();


    autocomplete.addListener('place_changed', () => {
        console.log('place changed...');
        var place = autocomplete.getPlace();
        geoSearchSubmitted(place)
    });

    document.getElementById('geoLocateButton').addEventListener('click', () => {
        console.log('button pressed');
        geoSearchSubmitted(place)
    });

}

function geoSearchSubmitted(place) {
    $('#geoLocateForm').closest('.cities-list-block').addClass('is-loading');

    if (place && place.geometry) {

        //if this is a request for canada, just show the canada tab.
        if (isAddressCanda(place.address_components)) {
            $('#geoLocateForm').closest('.cities-list-block').removeClass('is-loading');
            switchToCanda();
            return;
        }

        document.getElementById('lat').value = place.geometry['location'].lat();
        document.getElementById('lng').value = place.geometry['location'].lng();
        document.getElementById('geoLocateForm').submit();
    } else {
        // if they just pressed enter assuming they were selecting the top item
        if ($(".pac-container .pac-item:first span:eq(3)").text() == "")
            var firstResult = $(".pac-container .pac-item:first .pac-item-query").text();
        else
            var firstResult = $(".pac-container .pac-item:first .pac-item-query").text() + ", " + $(".pac-container .pac-item:first span:eq(3)").text();

        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
            "address": firstResult
        }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                lat = results[0].geometry.location.lat();
                lng = results[0].geometry.location.lng();
                placeName = results[0].address_components[0].long_name;

                //if this is a request for canada, just show the canada tab.
                if (isAddressCanda(results[0].address_components)) {
                    $('#geoLocateForm').closest('.cities-list-block').removeClass('is-loading');
                    switchToCanda();
                    return;
                }

                $("#citiesAutoComplete").val(firstResult);
                document.getElementById('lat').value = lat;
                document.getElementById('lng').value = lng;
                document.getElementById('geoLocateForm').submit();

            } else {
                alert('We could not find a matching location for the text entered. Please try again.');
                $('#geoLocateForm').closest('.cities-list-block').removeClass('is-loading');
                return;
            }
        });

    }
}

function isAddressCanda(address_components) {

    for (const component of address_components) {
        const componentType = component.types[0];
        switch (componentType) {
            case "country":
                if (component.long_name == 'Canada') {
                    return true;
                    break;
                }
        }
    }

    return false;

}


function switchToCanda() {
    if ($('#canadaTab').length) {
        $('#canadaTab').trigger('click');
    } else {
        let path = window.location.href.split('?')[0];
        window.location.href = path + '?showCanada=true';
    }
}

